import Button from "components/atoms/Button/Button";
import { FormattedMessage, useIntl } from "react-intl";

type InvoiceFormConfirmationProps = {
  onSubmit: any;
  isLoading: boolean;
};

function InvoiceFormConfirmation(props: InvoiceFormConfirmationProps) {
  const intl = useIntl();
  const { onSubmit, isLoading } = props;
  return (
    <div className="w-100 d-flex justify-content-between align-items-center">
      <h5>
        <FormattedMessage id="quotation-form.confirmation" defaultMessage="Confirmation" />
      </h5>
      <Button
        variant="primary"
        className="rounded-pill"
        onClick={onSubmit}
        label={intl.formatMessage({
          id: "general.submit",
          defaultMessage: "Submit",
        })}
        isLoading={isLoading}
      />
    </div>
  );
}

export default InvoiceFormConfirmation;
